import ClientPortal from "./ClientPortal";
import AdminPanel from "./AdminPanel";

export default function App() {
  const path = window.location.pathname;
  if (path.startsWith("/admin")) return <AdminPanel />;
  if (path.startsWith("/cliente/")) return <ClientPortal />;
  return (
    <div style={{ minHeight: "100vh", background: "#071829", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Georgia, serif" }}>
      <div style={{ fontSize: 14, color: "#6a8aaa" }}>Grupo Nunchi — Portal de Clientes</div>
    </div>
  );
}
